export default [
    {path: 'add'},      
    {path: 'edit/:item_id'} ,     
    {path: 'details/:item_id'} ,
]